

import { HTMLAttributes, ReactElement } from "react";

interface Props extends HTMLAttributes<HTMLElement> {
    color?: string;
}

function NotificationFooter({ color }: Props): ReactElement {

    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 19.5C8.65503 21.2478 10.4225 22.5 12.5 22.5C14.5775 22.5 16.345 21.2478 17 19.5" stroke={color ? color : "#155a9e"} strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M19.2491 10.2096V9.50497C19.2491 5.63623 16.2274 2.5 12.5 2.5C8.77256 2.5 5.75087 5.63623 5.75087 9.50497V10.2096C5.75087 11.0552 5.50972 11.8818 5.0578 12.5854L3.95036 14.3095C2.93882 15.8843 3.71105 18.0249 5.47036 18.5229C10.0727 19.8257 14.9273 19.8257 19.5296 18.5229C21.289 18.0249 22.0612 15.8843 21.0496 14.3095L19.9422 12.5854C19.4903 11.8818 19.2491 11.0552 19.2491 10.2096Z" stroke={color ? color : "#424242"} strokeWidth="1.5"/>
        <path d="M12.5 6.5V10.5" stroke={color ? color : "#155a9e"} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    );
}

export default NotificationFooter;